import { render, staticRenderFns } from "./link-with-icon.vue?vue&type=template&id=08c4cbdb&scoped=true&"
import script from "./link-with-icon.vue?vue&type=script&lang=js&"
export * from "./link-with-icon.vue?vue&type=script&lang=js&"
import style0 from "./link-with-icon.vue?vue&type=style&index=0&id=08c4cbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4cbdb",
  null
  
)

export default component.exports